import React from 'react';
import Box from '@nubank/nuds-web/components/Box/Box';

import WebsiteProvider from '@nubank/www-latam-commons/components/WebsiteProvider/WebsiteProvider';

import esMXLocalMessages from '../../locale/es-MX.json';
import ContractPageSEO from '../../components/ContractPageSEO/ContractPageSEO';
import HeaderXP from '../../components/HeaderXP/HeaderXP';
import MenuWrapper from '../../components/HeaderXP/MenuWrapper/MenuWrapper';
import FooterContractPages from '../../components/FooterXP/FooterContractPages';

const locale = process.env.NEXT_PUBLIC_WWW_LOCALE;
const DEFAULT_ROUTE_KEY_META_DATA = 'HOME';

const contractPage = (WrappedComponent, options = {}) => {
  const hocOptions = {
    routeKey: DEFAULT_ROUTE_KEY_META_DATA,
    ...options,
  };

  const ContractPageComponent = props => {
    const { routeKey } = hocOptions;
    // eslint-disable-next-line react/prop-types
    const { seo } = props;

    return (
      <WebsiteProvider
        locale={locale}
        messages={{ ...esMXLocalMessages }}
        enablePolyfill={false}

      >
        <ContractPageSEO routeKey={routeKey} data={seo} />

        <HeaderXP>
          <MenuWrapper
            hideCTAButton
            isWhiteColorHero
          />
        </HeaderXP>
        <Box
          id="main-content"
          display="flex"
          flexDirection="column"
          flex="1"
          minHeight="100vh"
          paddingHorizontal={{ xs: '8x', lg: '56px' }}
          paddingTop="36x"
        >
          <WrappedComponent {...props} />
        </Box>
        <FooterContractPages />
      </WebsiteProvider>

    );
  };

  if (WrappedComponent.getInitialProps) {
    ContractPageComponent.getInitialProps = async cyx => {
      const pageProps = await WrappedComponent.getInitialProps(cyx);

      return {
        ...pageProps,
      };
    };
  }

  return ContractPageComponent;
};

export default contractPage;
